<div class="row mt-4 no-gutters">
  <div class="col-12">

    <!-- hidden for now -->
    <!-- <div class="col-12 pl-0 text-right">
      <button class="btn btn-primary" (click)="addTcuDevice.getDeviceSettings();">Update Device</button>
    </div> -->

    <app-device-summary #deviceSummary [inDeviceData]="deviceData"></app-device-summary>
    <!-- <app-device-summary #deviceSummary [deviceId]="deviceData.id"></app-device-summary> -->

    <!--Package Services start-->
    <!-- <app-vehicle-summary [selectedVin]="deviceData.vin"></app-vehicle-summary> -->
    <!-- <app-vehicle-summary [selectedVin]="deviceData.vin" [selectedDeviceId]="deviceData.id"></app-vehicle-summary> -->
    <app-vehicle-summary [deviceData]="deviceData"
      (linkToVehicleDeviceResponseEmitter)="processLinkToVehicleDeviceResponse($event)"
      (vehicleDeviceUnlinkedEmitter)="deviceSummary.onVehicleDeviceUnlink($event); deviceHistory.onVehicleDeviceUnlink($event)"
      (deviceDataUpdateEmitter)="deviceSummary.updateDeviceData($event); deviceHistory.updateDeviceHistory($event);"></app-vehicle-summary>

    <!-- <app-device-history #deviceHistory [deviceData]="deviceData"></app-device-history> -->
    <app-device-history #deviceHistory [vin]="deviceData.vin" [deviceId]="deviceData.id"></app-device-history>

    <!-- <div class="row no-gutters">
      <div class="col-12 mt-4"><b>Device History</b></div>
      <div *ngIf="deviceDates && deviceDates.length>0; else noDeviceDates" class="col-12 my-3 table-responsive">
        <table class="table tbl-scrollable">
          <tbody class="max-height-57">
            <tr *ngFor="let deviceDate of deviceDates; let i = index">
              <td>
                <span class="text-secondary">{{deviceDate.key|customText}} : </span>
                <span *ngIf="deviceDate.value; else noDate">{{deviceDate.value | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</span>
                <ng-template #noDate><span>-</span></ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template class="col-12" #noDeviceDates>
        <div class="col-12 my-3 font13-400">
          Device history is not available.
        </div>
      </ng-template>
    </div> -->
  </div>
</div>

<!-- <app-add-tcu-device [vehicleData]="selectedVehicle" (saveEmitter)="getVehicleDetail()"
  #addTcuDevice></app-add-tcu-device> -->